import React from "react";
import moment, { Moment } from "moment";
import { FontSize, FontFamily } from "config/font";
import { Text } from "components/Typography/text.styled";
import {
  ArrowSign,
  MonthSelectContainer,
} from "../../../timeReport/monthlyOverview.styled";
import { TipGridHeader, TipHeadCell, ActionsHeadCell } from "../tips.styled";

type HeaderSectionProps = {
  currentDate: Moment;
  setCurrentDate: (date: Moment) => void;
  t: (key: string) => string;
};

export const HeaderSection: React.FC<HeaderSectionProps> = (props) => {
  const handlePreviousMonth = () => {
    props.setCurrentDate(moment(props.currentDate).subtract(1, "months"));
  };

  const handleNextMonth = () => {
    props.setCurrentDate(moment(props.currentDate).add(1, "months"));
  };

  const capitalizedMonth =
    props.currentDate.format("MMMM")[0].toUpperCase() +
    props.currentDate.format("MMMM").slice(1);

  return (
    <>
      <MonthSelectContainer>
        <ArrowSign
          onClick={handlePreviousMonth}
          title={props.t("CompanyTip.PreviousMonth")}
        >
          &#60;
        </ArrowSign>
        <Text
          fontSize={FontSize.H4}
          fontFamily={FontFamily.MontserratSemiBold}
          style={{ margin: 0 }}
        >
          {capitalizedMonth} {props.currentDate.year()}
        </Text>
        <ArrowSign
          onClick={handleNextMonth}
          title={props.t("CompanyTip.NextMonth")}
        >
          &#62;
        </ArrowSign>
      </MonthSelectContainer>

      <TipGridHeader>
        <TipHeadCell>
          <Text
            fontSize={FontSize.Large}
            fontFamily={FontFamily.MontserratSemiBold}
          >
            {props.t("CompanyTip.Date")}
          </Text>
        </TipHeadCell>
        <TipHeadCell>
          <Text
            fontSize={FontSize.Large}
            fontFamily={FontFamily.MontserratSemiBold}
          >
            {props.t("CompanyTip.EarnedTip")}
          </Text>
        </TipHeadCell>
        <TipHeadCell>
          <Text
            fontSize={FontSize.Large}
            fontFamily={FontFamily.MontserratSemiBold}
          >
            {props.t("CompanyTip.Remaining")}
          </Text>
        </TipHeadCell>
        <TipHeadCell>
          <Text
            fontSize={FontSize.Large}
            fontFamily={FontFamily.MontserratSemiBold}
          >
            {props.t("CompanyTip.Status")}
          </Text>
        </TipHeadCell>
        <ActionsHeadCell>
          <Text
            fontSize={FontSize.Large}
            fontFamily={FontFamily.MontserratSemiBold}
          >
            {props.t("CompanyTip.Manage")}
          </Text>
        </ActionsHeadCell>
      </TipGridHeader>
    </>
  );
};
